import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AnalysisProposalView from "@components/dashBoard/proposal/AnalysisProposalView";
import FirstProposalView from "@components/dashBoard/proposal/FirstProposalView";
import ProposalEditView from "@components/dashBoard/proposal/ProposalEditView";
import ProposalTree from "@components/dashBoard/proposal/ProposalTree";
import { reportTypeState } from "@recoil/assessmentState";
import { userInfoLoginState } from "@recoil/userState";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { PROPOSAL_ANALYSIS } from "@utils/Const";
import { useMemo, useState } from "react";
import { useAsync } from "react-async";
import { useOutletContext } from "react-router-dom";
import { useRecoilValue } from "recoil";
const ProposalMain = () => {
    const report = useRecoilValue(reportTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const { handleOpenPop } = useOutletContext();
    const [proposalTypeList, setProposalTypeList] = useState([
        { id: 1, type: PROPOSAL_ANALYSIS, name: "분석 보고서", description: "" },
    ]);
    const [treeSelected, setTreeSelected] = useState({
        id: 1,
        type: PROPOSAL_ANALYSIS,
        name: "분석 보고서",
        description: "",
    });
    //제안서 종류 조회 API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: "GET",
        appPath: `/proposal/types`,
        appQuery: {},
        userToken: userInfo.loginInfo.token, // url 직접 접근시 로그인 정보 사라짐..
    });
    useMemo(() => {
        if (data) {
            setProposalTypeList(data.data.list.map((element) => ({
                id: element.id,
                type: element.proposalType,
                name: element.proposalTypeName,
                description: element.description,
            })));
            setTreeSelected({
                id: data.data.list[0].id,
                type: data.data.list[0].proposalType,
                name: data.data.list[0].proposalTypeName,
                description: data.data.list[0].description,
            });
        }
    }, [data]);
    const [mobileTree, setMobileTree] = useState(false);
    const mobileTreeClick = () => {
        setMobileTree(!mobileTree);
    };
    return (_jsxs(_Fragment, { children: [report.checkType == "main" && (_jsxs("main", Object.assign({ className: "container report new" }, { children: [_jsx("div", Object.assign({ className: `treebar__toggleBtn ${mobileTree ? "active" : ""}`, onClick: mobileTreeClick }, { children: _jsx("p", { children: treeSelected.name }) })), _jsx("section", Object.assign({ className: "content w100p" }, { children: _jsx("article", Object.assign({ className: "box" }, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(ProposalTree, { proposalTypeList: proposalTypeList, treeSelected: treeSelected, setTreeSelected: setTreeSelected, mobileTree: mobileTree, setMobileTree: setMobileTree }), (() => {
                                        if (treeSelected.type == PROPOSAL_ANALYSIS) {
                                            return _jsx(AnalysisProposalView, { handleOpenPop: handleOpenPop, treeSel: treeSelected });
                                        }
                                        else {
                                            return _jsx(FirstProposalView, { handleOpenPop: handleOpenPop, treeSel: treeSelected });
                                        }
                                    })()] })) })) }))] }))), report.checkType == "proposal" && _jsx(ProposalEditView, {})] }));
};
export default ProposalMain;
